import apiClient from "./client";

export interface Category {
  id: string;
  name: string;
  isActive: boolean;
  createdAt: string;
  updatedAt: string;
}

export interface Show {
  id: string;
  name: string;
  hostName: string;
  description: string;
  thumbnail: string;
  categories: Category[];
  isActive: boolean;
  isRecurring: boolean;
  isSpecial: boolean;
  isFeatured:boolean;
  createdAt: string;
  updatedAt: string;
}

export interface ShowsResponse {
  success: boolean;
  message: string;
  data: {
    data: Show[];
    pagination: {
      total: number;
      page: number;
      limit: number;
      totalPages: number;
    };
  };
}

export const showsApi = {
  getShows: async (params: {
    page?: number;
    limit?: number;
    search?: string;
    status?: 'active' | 'inactive';
  }) => {
    const response = await apiClient.get<ShowsResponse>('/shows', { params });
    return response.data;
  },

  createShow: async (data: FormData) => {
    const response = await apiClient.post<ShowsResponse>('/shows', data, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  },

  updateShow: async (id: string, data: FormData) => {
    const response = await apiClient.patch<ShowsResponse>(`/shows/${id}`, data, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  },

  deleteShow: async (id: string) => {
    const response = await apiClient.patch<{ success: boolean; message: string }>(
      `/shows/${id}/delete`
    );
    return response.data;
  },

  updateShowStatus: async (id: string, data: { isActive: boolean }) => {
    const response = await apiClient.patch<ShowsResponse>(
      `/shows/${id}/status`,
      data
    );
    return response.data;
  },

  getShowById: async (id: string) => {
    const response = await apiClient.get<{ success: boolean; data: Show }>(
      `/shows/${id}`
    );
    return response.data;
  },
};
